/* eslint-disable */ import { childEntityRecipesComponent, memoEval, sceneEntityAddFabComponent, sceneEntityObjectPropertiesComponent, sceneEntityRemoteMaterialOverrideComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const countertopComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('Countertop').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/higgins.glb',
            objectName: 'COUNTERTOP',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'default', true).withEntity('Countertop').withGradualFilter({
        active: (self)=>self.$isIncluded
    }).attach(memoEval((self)=>[
            self.$material,
            self.$color
        ], ($material, $color)=>({
            fileUrl: '/models/higgins.glb',
            materialName: $material,
            materialsToOverride: [
                'countertopMaterial'
            ],
            color: $color
        }))),
    attachComponent.withComponent(sceneEntityRemoteMaterialOverrideComponent, 'excluded', true).withEntity('Countertop').withGradualFilter({
        active: (self)=>self.$isExcluded
    }).attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/higgins.glb',
            materialName: 'countertopMaterial',
            materialsToOverride: [
                'countertopMaterial'
            ],
            color: '#A3A3A3',
            transparent: true,
            alphaMapUrl: '/textures/semi-transparent.png'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'default', true).withEntity('Countertop').attach(memoEval((self)=>[
            self.$width
        ], ($width)=>({
            morphTargetInfluences: {
                width: {
                    value: $width,
                    scaleZero: 24,
                    scaleOne: 96
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addBaseCabinetFab', true).withEntity('Countertop').withGradualFilter({
        modes: [
            'owner'
        ],
        active: (self)=>self.$isStandaloneCountertop
    }).attach(memoEval(()=>[], ()=>({
            offsetX: 12,
            offsetY: 20,
            offsetZ: 12,
            instanceNames: [
                'baseCabinetWithoutCountertop'
            ],
            skipMenuWhenOnlyOne: true,
            hideWhenNone: true,
            showWhen: [
                'selected',
                'unselected'
            ],
            polarAngleLimits: {
                min: 1.4,
                max: 1.7
            },
            azimuthAngleLimits: {
                min: -0.1,
                max: 0.3
            }
        }))),
    attachComponent.withComponent(childEntityRecipesComponent, 'baseCabinetWithoutCountertop', true).withEntity('Countertop').attach(memoEval((self)=>[
            self.$baseCabinetWithoutCountertopRecipes
        ], ($baseCabinetWithoutCountertopRecipes)=>({
            groupLabel: 'Base Cabinet',
            recipes: $baseCabinetWithoutCountertopRecipes
        })))
];

//# sourceMappingURL=countertop.js.map